import Select from 'react-select'
import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useGetStatesQuery, useGetStateQuery } from '../store/atfStateApiSlice'
import { useGetRegionsQuery, useGetRegionQuery } from '../store/atfRegionApiSlice';
import { useGetPOIsQuery } from '../store/atfPoiApiSlice';
import { setCurrentState, setCurrentRegion, setPoiTypes, selectAllPoiTypes } from '../store/settingsSlices';
import { useGetCategoriesQuery } from '../store/atfCategoryApiSlice';
import SanitisedHtml from './SanitisedHtml';
import { selectParentCategories, selectCategoriesWithChildren } from '../store/selectors';
// import { Link } from 'react-router-dom';

import _ from 'lodash';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected
            ? 'white'
            : 'grey',
        padding: 5
    }),

    singleValue: (provided, state) => {
        const opacity = state.isDisabled
            ? 1
            : 1;
        const transition = 'opacity 300ms';

        return {
            ...provided,
            opacity,
            transition
        };
    }
}

const Header = () => {
    const dispatch = useDispatch();

    const { data: states = [], isLoading: statesFetching } = useGetStatesQuery();
    const { data: regions = [], isLoading: regionsFetching } = useGetRegionsQuery();
    const { data: entities = [] } = useGetPOIsQuery();
    const { data: categories = [], isLoading: categoriesFetching } = useGetCategoriesQuery();
    const parentCategories = useSelector(selectParentCategories);
    const categoriesWithChildren = useSelector(selectCategoriesWithChildren);

    const currentRegion = useSelector((state) => state.currentRegion.value)
    const currentState = useSelector((state) => state.currentState.value)

    const poiTypes = useSelector((state) => state.poiTypes.value)

    const handleStateChange = (newState) => {
        const wholeState = _.find(states, state => { return state.id === newState.value});
        dispatch(setCurrentState(wholeState));
        dispatch(setCurrentRegion(0));
        dispatch(selectAllPoiTypes());
        // onStateChange(newState);
    }

    const handleRegionChange = (newRegion) => {
        if(newRegion.value === 0){
            dispatch(setCurrentRegion(0));
        } else {
            const wholeRegion = _.find(regions, region => { return region.id === newRegion.value })
            dispatch(setCurrentRegion(wholeRegion));
        }
        dispatch(selectAllPoiTypes());
    }

    const isPoiTypeSelected = (poiTypeId) => poiTypes[poiTypeId] ?? true;

    const handleTogglePoiType = (poiTypeId, ids = [poiTypeId], showChildren = false) => {
        const selected = !_.every(ids, isPoiTypeSelected);
        dispatch(setPoiTypes({ids, selected}))
        if(selected && showChildren) setOpenPoiType(poiTypeId);
    }

    const getContentTitle = () => {
        if(currentRegion.id){
            return <SanitisedHtml html={currentRegion.title.rendered} as="span" />;
        } else if(currentState.id){
            return currentState.name;
        } else {
            return "Showing all states";
        }
    }

    const getContentDescription = () => {
        if(currentRegion.id){
            return <SanitisedHtml html={currentRegion.excerpt.rendered} />
        } else if(currentState.id){
            return <SanitisedHtml html={currentState.description} />
        } else {
            return "Select a state or region to see details";
        }
    }

    const [isVisible, setIsVisible] = useState(true);
    const toggleVisibility = () => setIsVisible(!isVisible);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [openPoiType, setOpenPoiType] = useState(0);
    const openCategory = _.find(categories, {id: openPoiType});
    const openChildren = _.filter(categories, {parent: openPoiType});
    const openChildIds = _.map(openChildren, 'id');
    const hasOtherPois = openCategory && _.some(entities, entity => {
        const ids = entity.atf_category ?? [];
        return _.includes(ids, openCategory.id) && _.isEmpty(_.intersection(ids, openChildIds));
    });

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const Modal = ({ isOpen, toggleModal }) => {
        if (!isOpen || _.isEmpty(categories) ) return null;

        const childCategories = _.filter(categories, c => {
            return !_.includes(parentCategories, c.id);
        })

        return (
            <div className="modal" onClick={toggleModal}>
                <div className="modal-content" onClick={e => e.stopPropagation()}>
                    <button className='text-gray-700 float-right mr-2' onClick={toggleModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 inline-block align-middle">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                        <span className="align-middle">Close</span>
                    </button>

                    <br />
                    <h2 className='text-gray-700 text-xl'>Map Legend</h2>
                    <div className="map-legends-icons-details mt-6">

                        {
                            _.map(childCategories, c => {
                                return <div className="icon-list-item" key={c.id}>
                                    <img src={c.meta.atf_icon || ""} alt="Placeholder" />
                                    <p className='text-gray-700 text-sm'>{c.description}</p>
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        );
    };


    return (
        <header className="header  md:fixed xm:relative">
            <div className="top-nav-wrapper bg-white p-2">
                <div className="container mx-auto p-2">
                    <div className="flex flex-wrap justify-between space-y-1">
                        <div className="w-50">
                            <a href='https://australiantroutfoundation.com.au/'>
                                <img className="object-contain h-10 w-100 float-left mt-0" src="atf-wide-logo.png" alt="" />
                            </a>
                        </div>

                        <div className="w-50">

                            <a href="https://australiantroutfoundation.com.au/business-directory-registration/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="atf-location-details-btn inline-flex items-center text-white top-left-cta text-sm"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                </svg>
                                <span className='mx-2'>PUT YOURSELF ON THE MAP</span>
                            </a>
                        </div>

                    </div>

                </div>
            </div>





            <div className='filterHeaderWrapper' >

                {isVisible && (

                    <div className="container mx-auto px-5 pt-2  filter-header">


                        <div className="select-control-wrapper pt-1 pb-0 xs:px-2 px-0">

                            <div className="flex flex-wrap gap-5">
                                <div className="">
                                    <p className="text-black text-sm">State</p>
                                    <Select
                                        options={ states.map(state => {
                                            return {
                                                value: state.id,
                                                label: state.name
                                            }
                                        }) }
                                        value={currentState.id ? 
                                            { value: currentState.id, label: currentState.name }
                                            : null}
                                        styles={customStyles}
                                        placeholder="Select State"
                                        onChange={handleStateChange} />
                                </div>
                                <div style={{maxWidth: 175}}>
                                    <p className="text-black text-sm">Region</p>
                                    <Select
                                        options={_.chain(regions)
                                            .filter(region => {
                                                return !currentState.id || region.atf_state.includes(currentState.id)
                                            })
                                            .map(region => {
                                                return {
                                                    value: region.id, 
                                                    label: region.title.rendered
                                                }
                                            })
                                            .sortBy('label')
                                            .unshift({ value: 0, label: 'Select...'})
                                            .value()
                                        }
                                        value={currentRegion.id ? 
                                            { value: currentRegion.id, label: currentRegion.title.rendered }
                                            : null}
                                        styles={customStyles}
                                        placeholder="Select Region"
                                        formatOptionLabel={({label}) => <SanitisedHtml html={label} as="span" />}
                                        onChange={handleRegionChange} />
                                </div>

                                <div className="">

                                    <p className="text-black text-sm">Filter By</p>

                                    <div className="atf-map-filter-wrapper">

                                        <div className="atf-map-filter">

                                            {
                                                _.map(categories, c => {
                                                    if(c.parent !== 0){
                                                        return null;
                                                    }

                                                    const ids = categoriesWithChildren[c.id] || [c.id];
                                                    const children = _.filter(categories, {parent: c.id});
                                                    const allSelected = _.every(ids, isPoiTypeSelected);
                                                    const someSelected = _.some(ids, isPoiTypeSelected);

                                                    return <div className="atf-map-filter-group" key={c.id}>
                                                            <label className="inline-flex items-center">
                                                            <input
                                                                type="checkbox"
                                                                className="form-checkbox atf-brand-color"
                                                                checked={allSelected}
                                                                ref={input => { if(input) input.indeterminate = someSelected && !allSelected; }}
                                                                onChange={() => handleTogglePoiType(c.id, ids, !_.isEmpty(children))} />
                                                            <span className="ml-1 text-black md:text-sm text-xs">
                                                                <SanitisedHtml html={c.name} as="span" />
                                                            </span>
                                                        </label>

                                                        {!_.isEmpty(children) ?
                                                        <button
                                                            type="button"
                                                            className={`atf-map-subfilter-toggle ${openPoiType === c.id ? 'is-open' : ''}`}
                                                            aria-label={`${openPoiType === c.id ? 'Hide' : 'Show'} ${c.name} subcategories`}
                                                            aria-expanded={openPoiType === c.id}
                                                            onClick={() => setOpenPoiType(openPoiType === c.id ? 0 : c.id)}>
                                                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                                                <path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </button>
                                                        : null}
                                                        </div>
                                                })
                                            }

                                        </div>

                                        <div className={`atf-map-subfilter ${openCategory ? 'is-open' : ''}`}>
                                            {openCategory ? <>
                                                <strong className="atf-map-subfilter-title">
                                                    <SanitisedHtml html={`${openCategory.name}:`} as="span" />
                                                </strong>
                                                {hasOtherPois ?
                                                <label className="inline-flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        className="form-checkbox atf-brand-color"
                                                        checked={isPoiTypeSelected(openCategory.id)}
                                                        onChange={() => handleTogglePoiType(openCategory.id)} />
                                                    <span className="ml-1 text-black md:text-sm text-xs">Other</span>
                                                </label>
                                                : null}
                                                {_.map(openChildren, child =>
                                                    <label className="inline-flex items-center" key={child.id}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-checkbox atf-brand-color"
                                                            checked={isPoiTypeSelected(child.id)}
                                                            onChange={() => handleTogglePoiType(child.id)} />
                                                        <span className="ml-1 text-black md:text-sm text-xs">
                                                            <SanitisedHtml html={child.name} as="span" />
                                                        </span>
                                                    </label>
                                                )}
                                            </> : null}
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="checkbox-wrapper mb-2">
                            <div className="grid grid-flow-col gap-3">
                                <div className="bg-gray-50 p-3 col-span-3 px-2 mt-2">
                                    <div className="state-region-info-box">
                                        <h2 className="sr-info-box-title text-black text-l pb-0">{getContentTitle()}</h2>
                                        {currentRegion.id
                                            ? <div className="text-gray-700 md:text-sm text-xs">{getContentDescription()}
                                                <a className='read-more-btn' href={currentRegion.link} target={'_blank'} rel="noreferrer">
                                                    Read more</a>
                                            </div>
                                            : <div className="text-gray-700">{getContentDescription()}</div>
                                        }

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}


                <div className="filterHeaderbtnWrapper pt-0 container px-5 mx-auto w-full my-2">
                    <button className='atf-location-details-btn flex justify-center align-middle' onClick={toggleVisibility}>

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5" />
                        </svg>

                        <span className='ml-2'>{isVisible ? 'Hide Filter Bar' : 'Show Filter Bar'}</span>


                    </button>


                    <button className="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center map-legends" onClick={toggleModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                        </svg>

                        <span className='ml-2'>Map Legend</span>
                    </button>

                    {/* Modal component */}
                    <Modal isOpen={isModalOpen} toggleModal={toggleModal} />
                </div>





            </div>












        </header>
    )
}

export default Header;
